import PropTypes from "prop-types";
import React, { useContext } from "react";
import { point } from "@turf/turf";
import greatCircle from "@turf/great-circle";
import _ from "lodash";
import { Divider, Icon } from "rsuite";
import axios from "axios";
import mapboxgl from "mapbox-gl";
import { createUseStyles } from "react-jss";
import { StyleTypeContext } from "../umbilical_tools";
import jssVariables, { buttonStylesType1 } from "../jss_setup";

// mapboxgl.workerClass =
//   // eslint-disable-next-line import/no-webpack-loader-syntax
//   require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const myButtonStyles = createUseStyles({
  btn: (props) => ({
    ...buttonStylesType1,
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: props.isSmallButton ? `calc(${jssVariables.normal_gap} * .8)` : 0,
    alignItems: "center",
    background: props.appearance === "primary" ? jssVariables.colors.base_color : "#f7f7fa",
    color: props.appearance === "primary" ? "#f7f7fa" : "#575757",
    fontSize: props.size === "xs" ? "small" : "medium",
    fontWeight: "bold",
    ..._.get(props, "customStyles.btn", {}),
  }),
});
const MyButton = (props) => {
  const { icon, appearance, size, onClick, isSmallButton } = props;
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const classes = myButtonStyles({
    appearance,
    size,
    isSmallButton,
    customStyles: cStyler({
      type,
      brand,
      objName: "tourViewMapMyButton",
    }),
  });

  return (
    <button className={classes.btn} onClick={onClick}>
      <Icon icon={icon} />
      {props.children}
    </button>
  );
};
MyButton.defaultProps = {
  icon: "",
  appearance: "primary",
  size: "xs",
  isSmallButton: false,
};
MyButton.propTypes = {
  isSmallButton: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
  appearance: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
export default class TourViewMap extends React.Component {
  constructor(props) {
    super(props);

    this.token =
      "pk.eyJ1IjoiZmlsb2RhbW9zIiwiYSI6ImNqemdneDltcTBpZWgzbnA2MmZycHRuaDUifQ.-U7GY0FFegKiJtR_Kg3OeA";

    this.state = {
      map: null,
      mode: "day___1",
      event: this.props.mapType === "pkg-map" ? "arrival" : "tour",
      day: "1",
      hidden: false,
    };

    this.center = this.center.bind(this);
    this.setMapMode = this.setMapMode.bind(this);
    this.setMapDayEvent = this.setMapDayEvent.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }
  componentDidMount() {
    this.setMap();
  }
  // map.addControl(new mapboxgl.NavigationControl(), "bottom-left");
  componentDidUpdate(prevProps) {
    const { map } = this.state;

    if (map && !map.loaded()) {
      map.once("load", () => this.initialActions());
    }
  }
  handleHide() {
    this.setState((p) => ({ ...p, hidden: true }));
  }
  handleShow() {
    this.setState((p) => ({ ...p, hidden: false }));
  }
  setMapMode(mode) {
    this.setState(
      (p) => ({ ...p, mode }),
      () => {
        this.setData();
        this.center();
      },
    );
  }
  setMapDayEvent(day, event) {
    this.setState(
      (p) => ({ ...p, day, event }),
      async () => {
        await this.setData();
        this.center();
      },
    );
  }
  setMap() {
    const { destinations, addon, mapType } = this.props;

    var lng = 0;
    var lat = 0;
    if (mapType === "pkg-map") {
      lng = _.get(destinations, "0.geodata.lng", -74.5);
      lat = _.get(destinations, "0.geodata.lat", 40);
    } else {
      lng = _.get(addon, "items.0.geodata.lng", -74.5);
      lat = _.get(addon, "items.0.geodata.lat", 40);
    }

    mapboxgl.accessToken = this.token;
    var map = new mapboxgl.Map({
      container: "TourView__map", // container ID
      style: "mapbox://styles/mapbox/streets-v11", // style URL
      center: [lng, lat], // starting position [lng, lat]
      zoom: 9, // starting zoom
      scrollZoom: false,
    });
    map.addControl(new mapboxgl.NavigationControl(), "bottom-left");

    this.setState((p) => ({ ...p, map }));
  }
  initialActions() {
    this.setSources();
    this.setLayers();
    this.setData();
    this.center();
  }
  async setData() {
    const { mapType } = this.props;

    if (mapType === "pkg-map") {
      this.setFlightData();
      this.setFlightRouteData();
      this.setAccData();
      await this.setTrfData();
    }

    this.setAddOnData();
  }
  setLayers() {
    const { mapType } = this.props;

    if (mapType === "pkg-map") {
      this.setDestLayers();
      this.setAccLayers();
      this.setTrfLayers();
      this.setFlightLayers();
    }

    this.setAddOnLayers();
  }
  setSources() {
    const { mapType } = this.props;

    if (mapType === "pkg-map") {
      this.setDestSources();
      this.setAccSources();
      this.setTrfSources();
      this.setFlightSources();
    }

    this.setAddOnSources();
  }
  // ========================== FLIGHT DATA ==========================
  setFlightSources() {
    const { map } = this.state;

    map.addSource("flightData", {
      type: "geojson",
      data: { type: "Feature", features: [] },
    });

    map.addSource("flightRouteData", {
      type: "geojson",
      data: {
        type: "Feature",
        properties: { visibility: "visible" },
        geometry: { type: "LineString", coordinates: [] },
      },
    });
  }
  setFlightLayers() {
    const { map } = this.state;

    map.addLayer({
      id: "flightRoute",
      type: "line",
      source: "flightRouteData",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: { "line-join": "round", "line-cap": "round" },
      paint: { "line-color": "#212e36", "line-width": 3 },
    });

    map.addLayer({
      id: "flightLayer",
      source: "flightData",
      type: "circle",
      paint: {
        "circle-stroke-width": 2,
        "circle-radius": 10,
        "circle-color": "#ffbe0f",
        "circle-stroke-color": "#212e36",
      },
    });

    map.addLayer({
      id: "flightText",
      source: "flightData",
      type: "symbol",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: {
        "text-field": ["concat", ["to-string", ["get", "order"]], ". ", ["get", "title"]],
        "text-allow-overlap": true,
        "text-max-width": 20,
        "text-size": 14,
        "text-offset": [0, 2],
      },
      paint: {
        "text-color": "black",
        "text-halo-color": "white",
        "text-halo-width": 2,
      },
    });
  }
  setFlightData() {
    const { map, mode, day, event } = this.state;
    const { dayByDayData } = this.props;

    if (!map) {
      return;
    }

    const flights = _.get(dayByDayData, `${day}.flights`, []).filter(
      (flight) => flight.events[day] === event,
    );

    map.getSource("flightData").setData({
      type: "FeatureCollection",
      features:
        mode !== "trip"
          ? _.flattenDeep(
              flights.map((flight) => {
                let origin = null;
                let destination = null;
                if (event === "arrival") {
                  origin = flight.legs[0][0].segments[0].origin_airport;
                  destination = _.last(flight.legs[0][0].segments).destination_airport;
                } else {
                  origin = _.last(flight.legs)[0].segments[0].origin_airport;
                  destination = _.last(_.last(flight.legs)[0].segments).destination_airport;
                }

                return [
                  {
                    type: "Feature",
                    properties: {
                      title: `(${origin.iata}) ${origin.name}`,
                      order: 1,
                      visibility: "visible",
                      type: "flight",
                    },
                    geometry: {
                      type: "Point",
                      coordinates: [origin.lng, origin.lat],
                    },
                  },
                  {
                    type: "Feature",
                    properties: {
                      title: `(${destination.iata}) ${destination.name}`,
                      order: 2,
                      visibility: "visible",
                      type: "flight",
                    },
                    geometry: {
                      type: "Point",
                      coordinates: [destination.lng, destination.lat],
                    },
                  },
                ];
              }),
            )
          : [],
    });
  }
  setFlightRouteData() {
    const { map, day, event } = this.state;
    const { dayByDayData } = this.props;

    const flights = _.get(dayByDayData, `${day}.flights`, []).filter(
      (flight) => flight.events[day] === event,
    );

    let points = [];
    flights.forEach((flight) => {
      let origin = null;
      let destination = null;
      if (event === "arrival") {
        origin = flight.legs[0][0].segments[0].origin_airport;
        destination = _.last(flight.legs[0][0].segments).destination_airport;
      } else {
        origin = _.last(flight.legs)[0].segments[0].origin_airport;
        destination = _.last(_.last(flight.legs)[0].segments).destination_airport;
      }

      points.push(origin);
      points.push(destination);
    });

    const getGreatCircleCoords = (start, end) => {
      const tstart = point(start);
      const tend = point(end);

      var gCircle = greatCircle(tstart, tend);
      return gCircle.geometry.coordinates;
    };

    var couples = [
      ..._.zip(
        points.map((d) => [d.lng, d.lat]),
        points.filter((d, idx) => idx > 0).map((d) => [d.lng, d.lat]),
      ),
    ].filter((couple) => couple.filter((c) => c).length === 2);

    var greatCircles = [];

    couples.forEach((c) => {
      getGreatCircleCoords(c[0], c[1]).forEach((cc) => {
        if (cc.length === 2 && cc[0] !== 180 && cc[0] !== -180) {
          greatCircles.push(cc);
        } else {
          cc.forEach((ccc) => {
            if (ccc[0] !== 180 && ccc[0] !== -180) {
              greatCircles.push(ccc);
            }
          });
        }
      });
    });

    map.getSource("flightRouteData").setData({
      type: "Feature",
      properties: { visibility: "visible" },
      geometry: {
        type: "LineString",
        coordinates: greatCircles,
      },
    });
  }
  // ======================== DESTINATION DATA =======================
  setDestSources() {
    const { map } = this.state;

    try {
      map.addSource("destData", {
        type: "geojson",
        data: { type: "Feature", features: [] },
      });

      map.addSource("destRouteData", {
        type: "geojson",
        data: {
          type: "Feature",
          properties: { visibility: "visible" },
          geometry: { type: "LineString", coordinates: [] },
        },
      });
    } catch (error) {}
  }
  setDestLayers() {
    const { map } = this.state;

    map.addLayer({
      id: "route",
      type: "line",
      source: "destRouteData",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: { "line-join": "round", "line-cap": "round" },
      paint: { "line-color": "#212e36", "line-width": 3 },
    });

    map.addLayer({
      id: "destinationLayer",
      source: "destData",
      type: "circle",
      filter: ["==", ["get", "type"], "destination"],
      paint: {
        "circle-stroke-width": 2,
        "circle-radius": 20,
        "circle-color": "#7bcacf",
        "circle-stroke-color": "#212e36",
      },
    });

    map.addLayer({
      id: "destText",
      source: "destData",
      type: "symbol",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: {
        "text-field": ["concat", ["to-string", ["get", "order"]], ". ", ["get", "title"]],
        "text-allow-overlap": true,
        "text-max-width": 20,
        "text-size": 14,
      },
      paint: {
        "text-color": "black",
        "text-halo-color": "white",
        "text-halo-width": 2,
      },
    });
  }
  setDestData() {
    const { map, mode } = this.state;
    const { destinations } = this.props;

    if (!map) {
      return;
    }

    map.getSource("destData").setData({
      type: "FeatureCollection",
      features:
        mode === "trip"
          ? destinations.map((dest) => ({
              type: "Feature",
              properties: {
                title: dest.name_en,
                order: dest.order,
                visibility: "visible",
                type: "destination",
              },
              geometry: {
                type: "Point",
                coordinates: [dest.geodata.lng, dest.geodata.lat],
              },
            }))
          : [],
    });
  }
  setDestRouteData() {
    const { map } = this.state;
    const { destinations } = this.props;

    const getGreatCircleCoords = (start, end) => {
      const tstart = point(start);
      const tend = point(end);

      var gCircle = greatCircle(tstart, tend);
      return gCircle.geometry.coordinates;
    };

    var couples = [
      ..._.zip(
        destinations.map((d) => [d.geodata.lng, d.geodata.lat]),
        destinations.filter((d, idx) => idx > 0).map((d) => [d.geodata.lng, d.geodata.lat]),
      ),
    ].filter((couple) => couple.filter((c) => c).length === 2);

    var greatCircles = [];

    couples.forEach((c) => {
      getGreatCircleCoords(c[0], c[1]).forEach((cc) => {
        if (cc.length === 2 && cc[0] !== 180 && cc[0] !== -180) {
          greatCircles.push(cc);
        } else {
          cc.forEach((ccc) => {
            if (ccc[0] !== 180 && ccc[0] !== -180) {
              greatCircles.push(ccc);
            }
          });
        }
      });
    });

    map.getSource("destRouteData").setData({
      type: "Feature",
      properties: { visibility: "visible" },
      geometry: {
        type: "LineString",
        coordinates: greatCircles,
      },
    });
  }
  // ========================= ACCOMMODATIONS ========================
  setAccSources() {
    const { map } = this.state;

    map.addSource("accData", {
      type: "geojson",
      data: { type: "Feature", features: [] },
    });
  }
  setAccLayers() {
    const { map } = this.state;

    map.addLayer({
      id: "accLayer",
      source: "accData",
      type: "circle",
      // filter: ["==", ["get", "type"], "destination"],
      paint: {
        "circle-stroke-width": 2,
        "circle-radius": 20,
        "circle-color": "#7bcacf",
        "circle-stroke-color": "#212e36",
      },
    });

    map.addLayer({
      id: "accText",
      source: "accData",
      type: "symbol",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: {
        "text-field": ["concat", ["to-string", ["get", "order"]], ". ", ["get", "title"]],
        "text-allow-overlap": true,
        "text-max-width": 20,
        "text-size": 14,
      },
      paint: {
        "text-color": "black",
        "text-halo-color": "white",
        "text-halo-width": 2,
      },
    });
  }
  setAccData() {
    const { map, day, event } = this.state;
    const { dayByDayData } = this.props;

    if (!map) {
      return;
    }

    var features = [];
    if (["check_in", "check_out"].includes(event)) {
      const acc = _.get(dayByDayData, `${day}.accommodations`, []).find(
        (acc) => acc.events[day] === event,
      );

      features = [
        {
          type: "Feature",
          properties: {
            title: acc.metadata.name,
            visibility: "visible",
            type: "accommodation",
          },
          geometry: {
            type: "Point",
            coordinates: [acc.metadata.geodata.lng, acc.metadata.geodata.lat],
          },
        },
      ];
    }

    map.getSource("accData").setData({ type: "FeatureCollection", features });
  }
  // =========================== TRANSFERS ===========================
  setTrfSources() {
    const { map } = this.state;

    map.addSource("trfData", {
      type: "geojson",
      data: { type: "Feature", features: [] },
    });

    map.addSource("trfRouteData", {
      type: "geojson",
      data: {
        type: "Feature",
        properties: { visibility: "visible" },
        geometry: { type: "LineString", coordinates: [] },
      },
    });
  }
  setTrfLayers() {
    const { map } = this.state;

    map.addLayer({
      id: "trfRoute",
      type: "line",
      source: "trfRouteData",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: { "line-join": "round", "line-cap": "round" },
      paint: { "line-color": "#212e36", "line-width": 3 },
    });

    map.addLayer({
      id: "trfLayer",
      source: "trfData",
      type: "circle",
      paint: {
        "circle-stroke-width": 2,
        "circle-radius": 10,
        "circle-color": "#8c0000",
        "circle-stroke-color": "#212e36",
      },
    });

    map.addLayer({
      id: "trfText",
      source: "trfData",
      type: "symbol",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: {
        "text-field": ["concat", ["to-string", ["get", "order"]], ". ", ["get", "title"]],
        "text-allow-overlap": true,
        "text-max-width": 20,
        "text-size": 14,
        "text-offset": [0, 2],
      },
      paint: {
        "text-color": "black",
        "text-halo-color": "white",
        "text-halo-width": 2,
      },
    });
  }
  async fetchDirections(points) {
    const pointsStr = points.map((point) => `${point[0]},${point[1]}`).join(";");

    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${pointsStr}?access_token=${this.token}`;

    const rq = axios.create({
      baseURL: url,
    });

    try {
      const result = await rq.get(url, {
        params: { geometries: "geojson", overview: "full" },
      });

      const route = _.get(result, "data.routes.0");
      if (!route) {
        return null;
      }

      const { geometry, distance, duration } = route;
      return { geometry, distance, duration };
    } catch (error) {
      return null;
    }
  }
  async setTrfData() {
    const { map, day, event } = this.state;
    const { dayByDayData } = this.props;

    if (!map) {
      return;
    }

    var features = [];
    var coordinates = [];
    if (["inbound", "outbound"].includes(event)) {
      const transfer = _.get(dayByDayData, `${day}.transfers`, []).find(
        (trf) => trf.events[day] === event,
      );

      const origin = event === "inbound" ? transfer.origin : transfer.destination;
      const destination = event === "inbound" ? transfer.destination : transfer.origin;

      const directions = await this.fetchDirections([
        [origin.geodata.lnt, origin.geodata.lat],
        [destination.geodata.lnt, destination.geodata.lat],
      ]);

      features = [
        {
          type: "Feature",
          properties: {
            title: origin.name,
            visibility: "visible",
            type: "transfer",
            event,
          },
          geometry: {
            type: "Point",
            coordinates: [origin.geodata.lnt, origin.geodata.lat],
          },
        },
        {
          type: "Feature",
          properties: {
            title: destination.name,
            visibility: "visible",
            type: "transfer",
            event,
          },
          geometry: {
            type: "Point",
            coordinates: [destination.geodata.lnt, destination.geodata.lat],
          },
        },
      ];

      coordinates = _.get(directions, "geometry.coordinates", []);
    }

    map.getSource("trfData").setData({ type: "FeatureCollection", features });

    map.getSource("trfRouteData").setData({
      type: "Feature",
      properties: { visibility: "visible" },
      geometry: { type: "LineString", coordinates },
    });
  }
  // ============================ ADD ONS ============================
  setAddOnSources() {
    const { map } = this.state;

    try {
      map.addSource("addOnData", {
        type: "geojson",
        data: { type: "Feature", features: [] },
      });
      map.addSource("addOnRouteData", {
        type: "geojson",
        data: {
          type: "Feature",
          properties: { visibility: "visible" },
          geometry: { type: "LineString", coordinates: [] },
        },
      });
    } catch (error) {
      return;
    }
  }
  setAddOnLayers() {
    const { map } = this.state;
    map.addLayer({
      id: "addOnRoute",
      type: "line",
      source: "addOnRouteData",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: { "line-join": "round", "line-cap": "round" },
      paint: { "line-color": "#212e36", "line-width": 3 },
    });

    const layerMapping = [
      ["highlight", "#33b2db"],
      ["food_and_drink", "#f0ad74"],
      ["shopping", "#7ecb94"],
    ];

    layerMapping.forEach((mapp) => {
      map.addLayer({
        id: `addOnLayer-${mapp[0]}`,
        source: "addOnData",
        type: "circle",
        filter: ["==", ["get", "type"], mapp[0]],
        paint: {
          "circle-stroke-width": 2,
          "circle-radius": 10,
          "circle-color": mapp[1],
          "circle-stroke-color": "#212e36",
        },
      });
    });

    // map.addLayer({
    //   id: "addOnIndex",
    //   source: "addOnData",
    //   type: "symbol",
    //   filter: ["==", ["get", "visibility"], "visible"],
    //   layout: {
    //     "text-field": ["to-string", ["get", "order"]],
    //     "text-allow-overlap": false,
    //     "text-max-width": 20,
    //     "text-size": 12,
    //   },
    //   paint: {
    //     "text-color": "white",
    //     "text-halo-color": "rgba(255,255,255,0.3)",
    //     "text-halo-width": 1,
    //   },
    // });

    map.addLayer({
      id: "addOnText",
      source: "addOnData",
      type: "symbol",
      filter: ["==", ["get", "visibility"], "visible"],
      layout: {
        "text-field": ["get", "title"],
        "text-allow-overlap": false,
        "text-max-width": 20,
        "text-size": 13,
        "text-offset": [0, 1.5],
      },
      paint: {
        "text-color": "black",
        "text-halo-color": "white",
        "text-halo-width": 2,
      },
    });
  }
  setAddOnData() {
    const { map, day, event } = this.state;
    const { dayByDayData, addon, mapType } = this.props;

    if (!map) {
      return;
    }

    var features = [];
    var coordinates = [];

    if (event === "tour") {
      var addons = [];
      if (mapType === "pkg-map") {
        addons = _.get(dayByDayData, `${day}.addons`, []);
      } else {
        addons.push(addon);
      }

      features = _.flatten(
        addons.map((addon) => {
          const groupedByPoint = _.groupBy(
            _.get(addon, "items", []),
            (item) => `${item.data.geodata.lng}___${item.data.geodata.lat}`,
          );

          return Object.entries(groupedByPoint).map(([group, points]) => {
            const item = points[0];
            return {
              type: "Feature",
              properties: {
                title: item.data.name_en,
                order: item.order,
                visibility: "visible",
                type: item.type,
                event,
              },
              geometry: {
                type: "Point",
                coordinates: [item.data.geodata.lng, item.data.geodata.lat],
              },
            };
          });
        }),
      );

      coordinates = _.flatten(
        addons.map((addon) =>
          _.flatten(
            _.get(addon, "items", []).map((item) => {
              return _.get(item, "departure_route.geometry.coordinates", []);
            }),
          ),
        ),
      );
    }

    map.getSource("addOnData").setData({ type: "FeatureCollection", features });

    map.getSource("addOnRouteData").setData({
      type: "Feature",
      properties: { visibility: "visible" },
      geometry: { type: "LineString", coordinates },
    });
  }
  center() {
    const { map, event } = this.state;
    const { mapType } = this.props;

    if (!map) {
      return;
    }

    const points = [];

    const centerToPoints = (map, points, zoom) => {
      var bounds = new mapboxgl.LngLatBounds();
      var validPoints = [];
      points
        .filter((couple) => couple[1] <= 90 && couple[1] >= -90)
        .filter((couple) => couple[0] !== 0 && couple[1] !== 0)
        .filter((couple) => couple.every((point) => typeof point !== "undefined"))
        .forEach((couple) => {
          bounds.extend(new mapboxgl.LngLat(couple[0], couple[1]));
          validPoints.push(couple);
        });

      validPoints = [...new Set(validPoints.map((point) => point.toString()))].map((point) =>
        point.split(",").map((coord) => parseFloat(coord)),
      );

      const options = { padding: 100, duration: 1000 };

      if (points.length === 1) {
        map.flyTo({ center: points[0], zoom: 16 });
        return;
      }

      if (validPoints.length) {
        map.fitBounds(bounds, { ...options });
      }
    };

    if (mapType === "pkg-map" && ["check_in", "check_out"].includes(event)) {
      map.getSource("accData")._data.features.forEach((f) => points.push(f.geometry.coordinates));
    } else if (mapType === "pkg-map" && ["arrival", "departure"].includes(event)) {
      map
        .getSource("flightData")
        ._data.features.forEach((f) => points.push(f.geometry.coordinates));
    } else if (mapType === "pkg-map" && ["inbound", "outbound"].includes(event)) {
      map.getSource("trfData")._data.features.forEach((f) => points.push(f.geometry.coordinates));
    } else if (event === "tour") {
      map.getSource("addOnData")._data.features.forEach((f) => points.push(f.geometry.coordinates));
    }

    const cPoints = points.filter((pp) => pp.every((p) => p !== 0));

    centerToPoints(map, cPoints, {
      zoom: 9,
    });
  }
  renderDayEventsBtn({ srvType, dayData, dayIdx, icon, event }) {
    const { day, event: stateEvent } = this.state;

    return _.get(dayData, srvType, [])
      .filter((srv) => srv.events[dayIdx] === event)
      .map((srv, idx) => {
        const event = srv.events[dayIdx];
        return (
          <MyButton
            icon={icon}
            appearance={day === dayIdx && event === stateEvent ? "primary" : "default"}
            key={idx}
            size="xs"
            onClick={() => {
              this.setMapDayEvent(dayIdx, event);
            }}
          >
            {_.startCase(event)}
          </MyButton>
        );
      });
  }
  renderActions() {
    const { mode, hidden } = this.state;
    const { dayByDayData, mapType } = this.props;

    const actionBtns = (
      <React.Fragment>
        <div
          className={`TourView__map__actions__btns ${
            hidden ? "TourView__map__actions__btns--hidden" : ""
          } ${mapType === "addon-map" ? "TourView__map__actions__btns--1" : ""}`}
        >
          {mapType === "pkg-map" ? (
            hidden ? (
              <MyButton
                icon={"tree-close"}
                appearance="primary"
                size="sm"
                onClick={this.handleShow}
                isSmallButton={true}
              >
                Show
              </MyButton>
            ) : (
              <MyButton
                size="sm"
                icon={"tree-open"}
                appearance="primary"
                onClick={this.handleHide}
                isSmallButton={true}
              >
                Hide
              </MyButton>
            )
          ) : null}
          <MyButton
            size="sm"
            icon={"map"}
            appearance="primary"
            onClick={this.center}
            isSmallButton={true}
          >
            Center Map
          </MyButton>
        </div>
      </React.Fragment>
    );

    if (mapType === "addon-map") {
      return (
        <div className={`TourView__map__actions TourView__map__actions--top-left`}>
          {actionBtns}
        </div>
      );
    }

    return (
      <div className={`TourView__map__actions TourView__map__actions--top-left`}>
        {dayByDayData ? (
          <React.Fragment>
            <span
              className={`TourView__map__actions__header ${
                hidden ? "TourView__map__actions__header--hidden" : ""
              }`}
            >
              <strong>Day By Day Overview</strong>
            </span>
            <div
              className={`TourView__map__actions__days ${
                hidden ? "TourView__map__actions__days--hidden" : ""
              }`}
            >
              {Object.entries(dayByDayData).map((dayEntry, idx) => {
                const dayIdx = dayEntry[0];
                const dayData = dayEntry[1];
                const active = mode === `day___${dayIdx}`;

                const kwargs = { dayData, dayIdx };
                return (
                  <div className="TourView__map__actions__days__day" key={idx}>
                    <MyButton
                      size="sm"
                      icon={"map-marker"}
                      appearance={active ? "primary" : "default"}
                      key={idx}
                      onClick={() => this.setMapMode(`day___${dayIdx}`)}
                    >
                      Day {dayIdx}
                    </MyButton>
                    {active ? (
                      <div className="TourView__map__actions__events">
                        {this.renderDayEventsBtn({
                          srvType: "accommodations",
                          icon: "h-square",
                          event: "check_out",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "transfers",
                          icon: "car",
                          event: "outbound",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "flights",
                          icon: "plane",
                          event: "departure",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "flights",
                          icon: "plane",
                          event: "arrival",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "transfers",
                          icon: "car",
                          event: "inbound",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "accommodations",
                          icon: "h-square",
                          event: "check_in",
                          ...kwargs,
                        })}
                        {this.renderDayEventsBtn({
                          srvType: "addons",
                          icon: "map-marker",
                          event: "tour",
                          ...kwargs,
                        })}
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        ) : null}
        <Divider
          className={`TourView__map__actions__divider ${
            hidden ? "TourView__map__actions__divider--hidden" : ""
          }`}
        />
        {actionBtns}
      </div>
    );
  }
  render() {
    return (
      <div id="TourView__map" className={`TourView__map TourView__map--${this.props.positioning}`}>
        {this.renderActions()}
      </div>
    );
  }
}
TourViewMap.defaultProps = {
  destinations: [],
  dayByDayData: {},
  mapType: "pkg-map",
  addon: {},
  positioning: "centered",
};
TourViewMap.propTypes = {
  dayByDayData: PropTypes.object,
  destinations: PropTypes.array,
  addon: PropTypes.object,
  mapType: PropTypes.oneOf(["pkg-map", "addon-map"]),
  positioning: PropTypes.oneOf(["centered", "full"]),
};
